import { useContext, useState } from 'react'
import LoginContext from '../../context';
import GamePopup from '../GamePopup';
const GameCard = ({ game }) => {
    // console.log("okokok", game);
    const { isAuthenticated, openLoginPopup, token } = useContext(LoginContext);
    const [popupLink, setPopupLink] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const handleClick = async (e) => {
        if (!isAuthenticated) {
            e.preventDefault();
            openLoginPopup();
            return;
        }
        try {
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/games/launch/${game?.id}`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token?.token}`,
                },
            });

            const data = await res.json();

            if (!res.ok) {
                alert(data?.message || 'Something went wrong launching the game.');
                return;
            }

            if (data?.launch_url) {
                setPopupLink(data.launch_url);
                // setIsPopupOpen(true);

                const width = window.innerWidth * 0.95;
                const height = window.innerHeight * 0.95;
                const left = (window.innerWidth - width) / 2;
                const top = (window.innerHeight - height) / 2;
                const newWindow = window.open(
                    data.launch_url,
                    '_blank',
                    `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`
                );
                if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
                    alert("Popup blocked! Please allow popups for this site.");
                }
            } else {
                console.error('No link returned from API:', data);
            }
        } catch (error) {
            console.error('Error launching game:', error);
        }
    }
    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupLink(null);
    };
    return (
        <>
            <div
                to={""}
                className='block w-full transition-all duration-300 ease-in-out hover:scale-[1.07] relative group h-full cursor-pointer'
                onClick={handleClick}>
                <div className="transition-all duration-300 overflow-hidden p-0.5 rounded-[13px] card-bg-gradient group-hover:card-bg-gradient-hover relative h-full">
                    <img src={game?.image} alt="" className='w-full overflow-hidden block  rounded-[13px] group-hover:filter group-hover:grayscale-[1] group-hover:brightness-[0.3] bg-black h-full object-contain' loading='lazy' />
                    <div className="absolute text-center transition-all duration-500 text-sm md:text-lg lg:text-xl xl:text-[25px] font-semibold z-[-1] top-1/2 -translate-y-1/2 text-white inset-x-0 blue-text-shadow group-hover:z-[9] opacity-0 group-hover:opacity-100">{game?.title_kr}
                        <h6 className=' block text-wrap break-all'>{game?.title}</h6>
                    </div>
                    {/* <div className="absolute text-center transition-all duration-500 text-xl font-bold z-[-1] top-[40%] inset-x-0">{gameTitle} <h6 className='text-xs block text-wrap break-all'>{englishGameTitle}</h6> </div> */}
                    {/* <div className="absolute text-center transition-all duration-500 ">{englishGameTitle} </div> */}
                </div>
            </div>
            {isPopupOpen && popupLink && (
                <GamePopup popupClose={closePopup} link={popupLink} />
            )}
        </>
    )
}
export default GameCard